module.exports = __webpack_public_path__ + "img/sword-earth-02.6fb15410.png";